module.exports = __webpack_public_path__ + "img/prioritas_vippack_dg_k.5c8b5ae9.png";